import { SWReactIcons, SWReactCountryIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export type Locations = Array<{ country: number; name: string }>;

interface IMetadataInfoProps {
    period: string;
    locations: Locations;
    onShareClick: () => void;
    onSettingsClick?: () => void;
}

const LocationsLabel = ({ locations }: { locations: Locations }) => {
    if (locations.length === 1) {
        const { country, name } = locations[0];

        return (
            <Flex
                alignItems="center"
                gap="8px"
            >
                <SWReactCountryIcons
                    countryCode={country}
                    size="xs"
                />
                <Text
                    fontVariant="chip1"
                    color={colorsPalettes.carbon["400"]}
                >
                    {name}
                </Text>
            </Flex>
        );
    }

    return (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <SWReactIcons
                iconName="location"
                size="xs"
            />
            <Tooltip content={locations.map(({ name }) => name).join(", ")}>
                <Text
                    fontVariant="chip1"
                    color={colorsPalettes.carbon["400"]}
                >
                    {locations.length} locations
                </Text>
            </Tooltip>
        </Flex>
    );
};

export const MetadataInfo = ({ period, locations, onShareClick, onSettingsClick }: IMetadataInfoProps) => {
    return (
        <Flex gap="16px">
            <Flex
                alignItems="center"
                gap="8px"
            >
                <SWReactIcons
                    iconName="daily-ranking"
                    iconColor={colorsPalettes.carbon["200"]}
                    size="xs"
                />
                <Text
                    fontVariant="chip1"
                    color={colorsPalettes.carbon["400"]}
                >
                    {period}
                </Text>
            </Flex>
            <Flex gap="16px">
                <LocationsLabel locations={locations} />

                <Flex gap="4px">
                    <Tooltip
                        content="Share"
                        placement="top"
                    >
                        <IconButton
                            iconName="share-social"
                            type="flatDark"
                            onClick={(event: MouseEvent) => {
                                event.stopPropagation();
                                event.preventDefault();
                                onShareClick();
                            }}
                        />
                    </Tooltip>
                    {onSettingsClick ? (
                        <Tooltip
                            content="Settings"
                            placement="top"
                        >
                            <IconButton
                                iconName="settings"
                                type="flatDark"
                                onClick={(event: MouseEvent) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    onSettingsClick();
                                }}
                            />
                        </Tooltip>
                    ) : null}
                </Flex>
            </Flex>
        </Flex>
    );
};
